// extracted by mini-css-extract-plugin
export default {"box":"dropzone-area_box__8iDT7","disabled":"dropzone-area_disabled__tdigv","active":"dropzone-area_active__02Msc","hint":"dropzone-area_hint__AN3u1"};